import { CFDClientEvent } from 'views/CustomerFacingDisplay/hardwareAgent/CFDClientEvent'
import { CFDClientMessage } from 'hooks/useHardwareAgent/CFD/types'
import { Subject } from 'rxjs'
type CFDEventArg = {
    type: CFDClientEvent.OnReceiveMessage
    params: CFDClientMessage
}
export const CFDSubjects = new Subject<CFDEventArg>()
